const files = [
  'table',
  'error',
  'mapper',
  'input',
  'date',
  'color',
  'files',
  'string'
]
let index = new Object()

files.forEach(file => {
  index[file] = require(`./${file}`).default
})

export default index
